export default __webpack_public_path__ + "static/giftregistry-a68ca23e3ff7440809133847adb7817d.svg";